import React, { useEffect, useState, useContext } from 'react';
import Header from '../elementos/basicos/Header';
import Cabecera from '../elementos/basicos/Cabecera';
import ContenedorCards from '../elementos/basicos/ContenedorCards';
import Row from 'react-bootstrap/Row';
import Footer from '../elementos/basicos/Footer';
import { StyleSheetManager } from 'styled-components';
import CondicionesCurso from '../elementos/basicos/CondicionesCurso';
import Card from '../elementos/basicos/Card';
import CargaCards from '../elementos/eventos/CargaCards';
import BuscadorCursos from '../elementos/eventos/BuscadorCursos';
import Paginacion from '../elementos/eventos/Paginacion';
import { AlertBusqueda } from '../elementos/eventos/Alerta';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchCursos } from '../../peticiones_API/Filtros_Consorci_Ocu';


const ConvocatoriaSinSub = (categoria) => {
  // console.log("categoria ",categoria);
  const location = useLocation();


  const [sinSubData, setSinSubData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [estadoBusqueda, setEstadoBusqueda] = useState(false);
  const [escribiendo, setEscribiendo] = useState(false);
  const [alerta, setAlerta] = useState(false);
  const [metadataCurso, setMetadataCurso] = useState(null);
  const [primeraCarga, setPrimeraCarga] = useState(true);
  const params = new URLSearchParams(location.search);
  const pagina = parseInt(params.get("pagina")) || 1;
  const busqueda = params.get("busqueda") || '';
  const urlPadre = window.location.pathname;
  const navigate = useNavigate();

  useEffect(() => {

    const inicializar = async () => {
      navigate(`${urlPadre}?pagina=1`);
      await gestionPeticionCursoSinSub(1, '');
      setPrimeraCarga(false);
    };
    inicializar();
  }, []);

  useEffect(() => {

    if (!primeraCarga) {
      const actualizarDatos = async () => {
        if (busqueda) {
          navigate(`${urlPadre}?pagina=${pagina}&busqueda=${busqueda}`);
          await gestionPeticionCursoSinSub(pagina, busqueda);
        } else {
          navigate(`${urlPadre}?pagina=${pagina}`);
          await gestionPeticionCursoSinSub(pagina, '');
        }
      };
      actualizarDatos();
    }
  }, [pagina, busqueda,urlPadre]);

  const gestionPeticionCursoSinSub = async (pagina, palabraBuscada) => {
    try {
      const responseData = await fetchCursos(pagina, palabraBuscada, categoria.categoria.urlCat);
      setMetadataCurso(responseData.meta);
      setSinSubData(responseData.data);

      if (responseData.data.length === 0) {
        setAlerta(true);
      } else {
        setAlerta(false);
      }
      setLoading(false);
    } catch (error) {
      console.error("Ha habido un error en cursos sin sub:", error);
    }
  };

  return (
    <>
      <Header />
      <StyleSheetManager shouldForwardProp={() => true}>
        <Cabecera
           Titulo={categoria.categoria.categoria.toUpperCase() ? categoria.categoria.categoria.toUpperCase() : "CATEGORÍA DESCONOCIDA"}
          Subtitulo="(100% SUBVENCIONADOS)"
          Texto_1="Cursos dirigidos a trabajadores de todos los sectores"
        />
      </StyleSheetManager>

      <BuscadorCursos
        placeholder="Introduce curso"
        palabra={busqueda}
        estadoBusqueda={estadoBusqueda}
        setEstadoBusqueda={setEstadoBusqueda}
        escribiendo={escribiendo}
        setEscribiendo={setEscribiendo}
        setAlerta={setAlerta}
      />

      <ContenedorCards>
        <Row className="justify-content-md-center">
          {loading || escribiendo ? (
            <CargaCards alineado={true} />
          ) : alerta ? (
            <AlertBusqueda mensaje="No hay ningún curso que coincida con tu búsqueda" estadoAlerta={alerta} />
          ) : (
            <Card elementosLista={sinSubData} categoria={categoria}  />
          )}
        </Row>
      </ContenedorCards>

      {metadataCurso !== null || loading === false ? (
        metadataCurso?.totalPages > 1 ? (
          <Paginacion
            currentPage={pagina}
            totalPages={metadataCurso.totalPages || 1}
          />
        ) : null
      ) : null}

      <CondicionesCurso />
      <Footer />
    </>
  );
};

export default ConvocatoriaSinSub;
